import { render } from "./field.vue?vue&type=template&id=66a7d37e"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"

import exportComponent from "/app/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__